var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-root',{staticClass:"main-layout"},[_c('nuxt'),_vm._v(" "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }